import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { listDepot, getpdf } from "../actions/depotActions";
// import "./table.css";
import Loader from "../components/Loader";
import Message from "../components/Message";

export default function Pdf({ pdf }) {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  return (
    <div>
      <div
        className="Container"
        dangerouslySetInnerHTML={{ __html: pdf }}
      ></div>
    </div>
  );
}
